import {
  addBrand,
  matchBrand,
  searchBrands,
  getFarmer,
  synctoERP,
  updateBrand,
  deleteFarmer,
  updateFarmer,
  addFarmer,
} from '@/adapters/master';
import { IDataModal } from '@/interfaces/data-modal';
import { IBrand, IFrm, IFrmRes } from '@/interfaces/master';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  Badge,
  Flex,
  Form,
  FormProps,
  Modal,
  notification,
  Radio,
  Select,
  Table,
  TableColumnsType,
  Button,
} from 'antd';
import { useEffect, useMemo, useState, useCallback, Suspense } from 'react';
import { uniqueId } from 'lodash';

const _modal: IDataModal<IFrm> = {
  open: false,
};

const FarmerPage: React.FC = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<IFrm[]>([]);
  const [action, setAction] = useState<'create' | 'update' | 'match'>('create');
  const [selected, setSelected] = useState<IFrm[]>([]);
  const [modal, setModal] = useState<IDataModal<IFrm>>({ ..._modal });
  const [form] = Form.useForm();
  const [tab, setTab] = useState<'create' | 'update'>('create');

  // const { data, refetch } = useQuery<IBrandRes, Error>({
  //   queryKey: ['search-brand-list'],
  //   queryFn: searchBrands,
  //   retry: 0,
  // });
  const { data, refetch } = useQuery<IFrmRes, Error>({
    queryKey: ['get-famer'],
    queryFn: getFarmer,
    retry: 0,
  });

  const actionFarmerMutation = useMutation({
    mutationFn: async (data: Partial<IFrm>) =>
      tab === 'create' ? await addFarmer(data) : await updateFarmer(data),
    mutationKey: tab === 'create' ? ['add-farmer'] : ['update-farmer'],
    onSuccess: data => {
      if (data.status === 'OK' && tab === 'create') {
        notification.success({ message: 'Sync Farmer สำเร็จ' });
        refetch();
      } else if (data.status === 'OK' && tab === 'update') {
        notification.success({ message: 'Update Farmer สำเร็จ' });
        refetch();
      } else {
        notification.error({ message: 'Sync Farmer ไม่สำเร็จ' });
      }
    },
    onError: error => {
      console.log('error', error);
    },
  });

  const handleSyncSelectedFarmers = async (selectedRows: any) => {
    await actionFarmerMutation.mutateAsync(selectedRows);
  };

  const actionDeleteFarmer = useMutation({
    mutationFn: async (data: Partial<IFrm>) => await deleteFarmer(data),
    mutationKey: ['delete-farmer'],
    onSuccess: data => {
      if (data.status === 'OK' && tab === 'update') {
        notification.success({ message: 'Delete Farmer สำเร็จ' });
        refetch();
      } else {
        notification.error({ message: 'Delete Farmer ไม่สำเร็จ' });
      }
    },
    onError: error => {
      console.log('error', error);
    },
  });

  // const handleSyncTOERP = async () => {
  //   await actionTOERP.mutateAsync();
  // };

  const handleDeleteFarmers = async (selectedRows: any) => {
    await actionDeleteFarmer.mutateAsync(selectedRows);
  };

  const handleUpdateFarmerCode = useCallback((item: IFrm) => {
    setModal({
      open: true,
      item: item,
    });
  }, []);

  const columns = useMemo(
    () =>
      [
        {
          title: 'ลำดับ',
          dataIndex: '',
          width: 40,
          align: 'center' as const,
          className: 'text-bold',
          render: (_: any, __: IFrm, i: number) => (
            <div className="font-weight-bold">{i + 1}</div>
          ),
        },
        {
          title: 'รหัส',
          dataIndex: 'FRM_CODE',
          defaultSortOrder: 'ascend',
          sorter: (a, b) =>
            Number(a.FRM_CODE.replace('FRM', '').replace('-', '')) -
            Number(b.FRM_CODE.replace('FRM', '').replace('-', '')),
          filterSearch: true,
          filters: Array.from(new Set(selected.map(item => item.FRM_CODE)))
            .sort(
              (a, b) =>
                Number(a?.replace(/\D/g, '').replace('-', '')) -
                Number(b?.replace(/\D/g, '').replace('-', '')),
            )
            .map(code => {
              return { text: code, value: code };
            }),
          onFilter: (value, record) => {
            return record?.FRM_CODE.startsWith(value as string);
          },
        },
        {
          title: 'ชื่อ',
          dataIndex: 'FRM_FNAME',
          sorter: (a, b) =>
            Number(a.FRM_FNAME?.replace(/\D/g, '').replace('-', '')) -
            Number(b.FRM_FNAME?.replace(/\D/g, '').replace('-', '')),
          filterSearch: true,
          filters: Array.from(new Set(selected.map(item => item.FRM_FNAME)))
            .sort(
              (a, b) =>
                Number(a?.replace(/\D/g, '').replace('-', '')) -
                Number(b?.replace(/\D/g, '').replace('-', '')),
            )
            .map(code => {
              return { text: code, value: code };
            }),
          onFilter: (value, record) => {
            return record?.FRM_FNAME.startsWith(value as string);
          },
        },
        {
          title: 'นามสกุล',
          dataIndex: 'FRM_LNAME',
          sorter: (a, b) =>
            Number(a.FRM_LNAME?.replace(/\D/g, '').replace('-', '')) -
            Number(b.FRM_LNAME?.replace(/\D/g, '').replace('-', '')),
          filterSearch: true,
          filters: Array.from(new Set(selected.map(item => item.FRM_LNAME)))
            .sort(
              (a, b) =>
                Number(a?.replace(/\D/g, '').replace('-', '')) -
                Number(b?.replace(/\D/g, '').replace('-', '')),
            )
            .map(code => {
              return { text: code, value: code };
            }),
          onFilter: (value, record) => {
            return record?.FRM_LNAME.startsWith(value as string);
          },
        },
        {
          title: 'ตำบล/แขวง',
          dataIndex: 'FRM_LINE2',
          sorter: (a, b) =>
            Number(a.FRM_LINE2?.replace(/\D/g, '').replace('-', '')) -
            Number(b.FRM_LINE2?.replace(/\D/g, '').replace('-', '')),
          filterSearch: true,
          filters: Array.from(new Set(selected.map(item => item.FRM_LINE2)))
            .sort(
              (a, b) =>
                Number(a?.replace(/\D/g, '').replace('-', '')) -
                Number(b?.replace(/\D/g, '').replace('-', '')),
            )
            .map(code => {
              return { text: code, value: code };
            }),
          onFilter: (value, record) => {
            return record?.FRM_LINE2.startsWith(value as string);
          },
        },
        {
          title: 'อำเภอ/เขต',
          dataIndex: 'FRM_LINE3',
          sorter: (a, b) =>
            Number(a.FRM_LINE3?.replace(/\D/g, '').replace('-', '')) -
            Number(b.FRM_LINE3?.replace(/\D/g, '').replace('-', '')),
          filterSearch: true,
          filters: Array.from(new Set(selected.map(item => item.FRM_LINE3)))
            .sort(
              (a, b) =>
                Number(a?.replace(/\D/g, '').replace('-', '')) -
                Number(b?.replace(/\D/g, '').replace('-', '')),
            )
            .map(code => {
              return { text: code, value: code };
            }),
          onFilter: (value, record) => {
            return record?.FRM_LINE3.startsWith(value as string);
          },
        },
        {
          title: 'จังหวัด',
          dataIndex: 'FRM_PROVICE',
          sorter: (a, b) =>
            Number(a.FRM_PROVICE?.replace(/\D/g, '').replace('-', '')) -
            Number(b.FRM_PROVICE?.replace(/\D/g, '').replace('-', '')),
          filterSearch: true,
          filters: Array.from(new Set(selected.map(item => item.FRM_PROVICE)))
            .sort(
              (a, b) =>
                Number(a?.replace(/\D/g, '').replace('-', '')) -
                Number(b?.replace(/\D/g, '').replace('-', '')),
            )
            .map(code => ({
              text: code,
              value: code,
            })),
          onFilter: (value, record) => {
            return record?.FRM_PROVICE?.startsWith(value as string);
          },
        },
      ] as TableColumnsType<IFrm>,
    [tab, selected, handleUpdateFarmerCode],
  );

  const insert = data?.insert;
  const update = data?.update;
  const match = data?.match;
  useEffect(() => {
    const listMap = { create: insert, update, match };
    setSelected(listMap[tab]?.map(c => ({ ...c, _key: uniqueId('b-') })) || []);
    setSelectedRowKeys([]);
  }, [tab, insert, update, match]);

  const rowSelection = {
    onChange: (_: React.Key[], selectedRows: IFrm[]) => {
      setSelectedRowKeys(selectedRows.map(row => row._key));
      setSelectedRows(selectedRows);
    },
    selectedRowKeys,
    getCheckboxProps: (record: IFrm) => ({
      disabled: action === 'match',
    }),
  };

  const [search, SetSearch] = useState('');

  const filteredData = useMemo(() => {
    return selected.filter(item => {
      const farmerCode = (item.FRM_CODE || '').toLowerCase();
      const searchValue = search.trim().toLowerCase();
      return !searchValue || farmerCode.includes(searchValue);
      // }
    });
  }, [selected, action, search]);

  return (
    <div>
      <Flex justify="space-between" gap={2} className="mb-3">
        <Flex gap={0}>
          <Radio.Group value={tab} onChange={e => setTab(e.target.value)}>
            <Radio.Button value="create">เพิ่ม</Radio.Button>
            <Radio.Button value="update">แก้ไข/ปรับปรุง</Radio.Button>
          </Radio.Group>
        </Flex>
        <Flex gap={12}>
          {tab === 'update' ? (
            <button
              type="button"
              className="btn btn-info"
              style={{ minWidth: 100 }}
              onClick={() => handleDeleteFarmers(selectedRows)}
            >
              {actionDeleteFarmer.isPending ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Loading...</span>
                </>
              ) : (
                'ลบข้อมูล Farmer'
              )}
            </button>
          ) : (
            <></>
          )}

          <button
            type="button"
            className="btn btn-success"
            style={{ minWidth: 100 }}
            disabled={!selectedRowKeys.length}
            onClick={() => handleSyncSelectedFarmers(selectedRows)}
          >
            {actionFarmerMutation.isPending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Loading...</span>
              </>
            ) : tab === 'create' ? (
              'ส่งข้อมูลไป OTOD >'
            ) : (
              'แก้ไขข้อมูลที่ OTOD >'
            )}
          </button>
        </Flex>
      </Flex>
      <Table<IFrm>
        rowSelection={{ type: 'checkbox', ...rowSelection }}
        columns={columns}
        dataSource={filteredData}
        size="small"
        bordered
        rowKey={r => r._key}
        pagination={false}
        locale={{ emptyText: 'ไม่พบรายการ' }}
      />
      <Suspense>
        <Modal
          open={modal.open}
          width={350}
          onCancel={() => setModal({ ..._modal })}
          // loading={matchBrandApi.isPending}
          // onOk={() => {
          //   form
          //     .validateFields()
          //     .then(values => {
          //       onFinish(values);
          //     })
          //     .catch(() => {
          //       // validation failed
          //     });
          // }}
        >
          <Form
            form={form}
            name="farmer"
            layout="vertical"
            // onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item<IFrm>
              label="รหัส"
              name="FRM_CODE"
              rules={[{ required: true }]}
            >
              <Select
                style={{ minWidth: 150 }}
                size="large"
                showSearch
                allowClear
                placeholder="ค้นหา"
                filterOption={(input, option) =>
                  ((option?.label as string) ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[...(insert || [])].sort().map(frm => ({
                  label: `${frm.FRM_CODE} - ${frm.FRM_CODE}`,
                  value: frm.FRM_CODE,
                }))}
              />
            </Form.Item>
          </Form>
        </Modal>
      </Suspense>
    </div>
  );
};

export default FarmerPage;
